export class AzureDiskSettings {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "string",
            "format": ""
        },
        {
            "name": "tier",
            "baseName": "tier",
            "type": "string",
            "format": ""
        },
        {
            "name": "hyperVGeneration",
            "baseName": "hyperVGeneration",
            "type": "string",
            "format": ""
        },
        {
            "name": "sizeBytes",
            "baseName": "sizeBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureDiskSettings.attributeTypeMap;
    }
    constructor() {
    }
}
